// extracted by mini-css-extract-plugin
export default {"nav":"LogOut_nav__OYRuO","link":"LogOut_link__GEgt+"};